import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function TermsPage() {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-border bg-background/80 backdrop-blur-md sticky top-0 z-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            <ArrowLeft size={16} />
            Volver
          </Link>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-indigo-500 to-violet-500 flex items-center justify-center">
              <span className="text-white font-bold text-sm">F</span>
            </div>
            <span className="text-lg font-bold text-foreground">Frappi</span>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 max-w-3xl">
        <h1 className="text-3xl font-bold text-foreground mb-2">Terminos de Uso</h1>
        <p className="text-sm text-muted-foreground mb-8">Ultima actualizacion: 1 de abril de 2026</p>

        <div className="prose prose-neutral dark:prose-invert max-w-none space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">1. Aceptacion de los Terminos</h2>
            <p className="text-muted-foreground leading-relaxed">
              Al descargar, instalar o utilizar la aplicacion Frappi (&quot;la Aplicacion&quot;), aceptas estar sujeto a estos Terminos de Uso. Si no estas de acuerdo con estos terminos, no utilices la Aplicacion.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">2. Descripcion del Servicio</h2>
            <p className="text-muted-foreground leading-relaxed">
              Frappi es una aplicacion de gestion educativa que permite a profesores y padres organizar tareas, calificaciones, eventos y planes de estudio de sus estudiantes, con funciones potenciadas por inteligencia artificial.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">3. Registro y Cuenta</h2>
            <ul className="list-disc list-inside text-muted-foreground space-y-1">
              <li>Debes proporcionar informacion veraz y actualizada al crear tu cuenta</li>
              <li>Eres responsable de mantener la confidencialidad de tu contrasena</li>
              <li>Debes ser mayor de 18 anos o contar con el consentimiento de un tutor legal</li>
              <li>Una cuenta es personal e intransferible</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">4. Planes y Suscripciones</h2>

            <h3 className="text-lg font-medium text-foreground mt-4 mb-2">4.1 Plan Gratuito</h3>
            <p className="text-muted-foreground leading-relaxed">
              El plan gratuito incluye funciones basicas con limites de uso (estudiantes, tareas, escaneos con IA y consultas de ayuda). Los limites pueden cambiar sin previo aviso.
            </p>

            <h3 className="text-lg font-medium text-foreground mt-4 mb-2">4.2 Plan Premium</h3>
            <p className="text-muted-foreground leading-relaxed">
              El plan Premium ofrece acceso ilimitado a todas las funciones. Esta disponible en modalidad mensual y anual.
            </p>

            <h3 className="text-lg font-medium text-foreground mt-4 mb-2">4.3 Periodo de Prueba</h3>
            <p className="text-muted-foreground leading-relaxed">
              El plan Premium incluye un periodo de prueba gratuito de 7 dias. Si no cancelas antes de que finalice el periodo de prueba, se realizara el cobro automaticamente.
            </p>

            <h3 className="text-lg font-medium text-foreground mt-4 mb-2">4.4 Pagos y Renovacion</h3>
            <ul className="list-disc list-inside text-muted-foreground space-y-1">
              <li>Los pagos se procesan a traves de Google Play</li>
              <li>Las suscripciones se renuevan automaticamente al final de cada periodo</li>
              <li>Puedes cancelar en cualquier momento desde la configuracion de Google Play</li>
              <li>No se realizan reembolsos por periodos parciales ya cobrados</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">5. Uso Aceptable</h2>
            <p className="text-muted-foreground leading-relaxed">Te comprometes a:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-1 mt-2">
              <li>Utilizar la Aplicacion solo para fines educativos y de gestion academica</li>
              <li>No intentar acceder a cuentas de otros usuarios</li>
              <li>No utilizar la IA para generar contenido danino, ilegal o inapropiado</li>
              <li>No realizar ingenieria inversa ni intentar explotar vulnerabilidades</li>
              <li>No usar la Aplicacion para spam o actividades comerciales no autorizadas</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">6. Contenido del Usuario</h2>
            <p className="text-muted-foreground leading-relaxed">
              Conservas la propiedad de todo el contenido que creas en Frappi (tareas, calificaciones, notas, imagenes). Al usar la Aplicacion, nos otorgas una licencia limitada para almacenar, procesar y mostrar tu contenido con el unico proposito de brindarte el servicio.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">7. Funciones de IA</h2>
            <p className="text-muted-foreground leading-relaxed">
              Las funciones de inteligencia artificial (escaneo de tareas, ayuda con deberes, planes de estudio) se proporcionan &quot;tal cual&quot;. Los resultados de la IA son sugerencias y no sustituyen el criterio profesional de un educador. Frappi no garantiza la precision o integridad de las respuestas generadas por IA.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">8. Disponibilidad del Servicio</h2>
            <p className="text-muted-foreground leading-relaxed">
              Nos esforzamos por mantener la Aplicacion disponible en todo momento, pero no garantizamos un funcionamiento ininterrumpido. Podemos realizar mantenimiento programado o de emergencia que resulte en interrupciones temporales.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">9. Limitacion de Responsabilidad</h2>
            <p className="text-muted-foreground leading-relaxed">
              Frappi se proporciona &quot;tal cual&quot; y &quot;segun disponibilidad&quot;. En la medida permitida por la ley, no seremos responsables por danos indirectos, incidentales o consecuentes derivados del uso de la Aplicacion, incluyendo la perdida de datos academicos.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">10. Terminacion</h2>
            <p className="text-muted-foreground leading-relaxed">
              Podemos suspender o terminar tu acceso a la Aplicacion si violas estos Terminos de Uso. Puedes eliminar tu cuenta en cualquier momento desde la configuracion de la Aplicacion, lo cual eliminara todos tus datos de forma permanente.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">11. Modificaciones</h2>
            <p className="text-muted-foreground leading-relaxed">
              Nos reservamos el derecho de modificar estos Terminos en cualquier momento. Los cambios significativos seran notificados a traves de la Aplicacion. El uso continuado despues de los cambios constituye tu aceptacion.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">12. Ley Aplicable</h2>
            <p className="text-muted-foreground leading-relaxed">
              Estos Terminos se rigen por las leyes aplicables en la jurisdiccion donde opera el usuario. Cualquier disputa se resolvera mediante negociacion directa en primera instancia.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">13. Contacto</h2>
            <p className="text-muted-foreground leading-relaxed">
              Para consultas sobre estos Terminos de Uso, contactanos en:
            </p>
            <p className="text-muted-foreground mt-2">
              <strong>Email:</strong>{' '}
              <a href="mailto:hola@frappi.app" className="text-primary hover:underline">
                hola@frappi.app
              </a>
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-border py-8 mt-12">
        <div className="container mx-auto px-4 text-center text-sm text-muted-foreground">
          &copy; {new Date().getFullYear()} Frappi. Todos los derechos reservados.
        </div>
      </footer>
    </div>
  );
}
